import { BaseProduct, ProductConfig } from "@utils/product/product-utils-types";
import {
  AllAddonsTypes,
  AllSubscriptionsTypes,
} from "@utils/product/product-types";
import { createProductsFromConfigs } from "@utils/product/product-utils";

const subscriptions: Record<AllSubscriptionsTypes, ProductConfig> = {
  ["sphere-xg-standard"]: {
    scopesWithoutLimit: ["COMPANY"],
    isCoreProduct: true,
  },
  ["sphere-xg-pro"]: {
    scopesWithoutLimit: ["COMPANY"],
    isCoreProduct: true,
  },
  ["sphere-xg-enterprise"]: {
    scopesWithoutLimit: ["COMPANY"],
    isCoreProduct: true,
  },
};

const addons: Record<AllAddonsTypes, ProductConfig> = {
  ["sphere-xg-addon-360"]: {
    scopesWithoutLimit: ["COMPANY"],
    isCoreProduct: true,
  },
  ["sphere-xg-addon-point-cloud"]: {
    scopesWithoutLimit: ["COMPANY"],
    isCoreProduct: true,
  },
};

/** List of all available subscriptions in Admin Panel */
export const allAvailableSubscriptions: Record<
  AllSubscriptionsTypes,
  BaseProduct
> = createProductsFromConfigs(subscriptions);

/** List of all available addons in Admin Panel */
export const allAvailableAddons: Record<AllAddonsTypes, BaseProduct> =
  createProductsFromConfigs(addons);
